import { createContext, ReactNode, useMemo } from "react";
import { nblyTheme } from "./nblyTheme";
import { Theme, ThemeProvider } from "@mui/material";

interface ThemeContextProps {
  theme: Theme;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);
export const GetBrandTheme = ({
  brandTheme,
  children,
}: {
  brandTheme: Theme;
  children: ReactNode;
}) => {
  const urlParams = new URLSearchParams(globalThis.location.search || "");
  const useNblyTheme = urlParams.has("leadconcept");
  const theme = useNblyTheme ? nblyTheme : brandTheme;
  const contextValue = useMemo(() => ({ theme }), [theme]);
  const themeClass = useNblyTheme ? "nbly-theme" : "";
  return (
    <ThemeContext.Provider value={contextValue}>
      <div className={themeClass}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </div>
    </ThemeContext.Provider>
  );
};
